import { DescriptionOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function ReviewedQSetListNoRowsOverlay() {
  return (
    <NoRowsOverlay title='ยังไม่มีชุดข้อสอบที่ตรวจสอบเสร็จสิ้น' icon={DescriptionOutlinedIcon} />
  );
}
